import { Component } from "react";
import { AlertTriangle } from "lucide-react";

const RELOAD_KEY = "mm_chunk_reload";

export const isChunkError = (e) =>
  e?.name === "ChunkLoadError" || /Loading (CSS )?chunk|dynamically imported module|Failed to fetch dynamically/i.test(e?.message || "");

// Reload once on stale-bundle chunk errors; a second failure falls through to the fallback UI.
export function reloadOnceForChunk(e) {
  if (!isChunkError(e) || sessionStorage.getItem(RELOAD_KEY)) return false;
  sessionStorage.setItem(RELOAD_KEY, "1");
  window.location.reload();
  return true;
}

export default class ErrorBoundary extends Component {
  state = { error: null, key: 0 };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info?.componentStack);
    reloadOnceForChunk(error);
  }

  retry = () => this.setState((s) => ({ error: null, key: s.key + 1 }));

  render() {
    if (!this.state.error) return <div key={this.state.key} className="contents">{this.props.children}</div>;
    const { title = "Algo ha fallado", sub = "No te preocupes, tus mensajes están a salvo. Vuelve a intentarlo.", backHref = "/" } = this.props;
    return (
      <div className="flex min-h-[100dvh] flex-col items-center justify-center bg-mist px-8 text-center" data-testid="error-fallback">
        <div className="mb-5 flex h-20 w-20 items-center justify-center rounded-[28px] bg-white shadow-[0_8px_30px_rgba(13,42,107,0.12)]">
          <AlertTriangle className="h-9 w-9 text-alert" strokeWidth={1.6} />
        </div>
        <h2 className="text-lg font-extrabold text-navy">{title}</h2>
        <p className="mt-2 max-w-xs text-sm text-slate-500">{sub}</p>
        <button className="btn-primary mt-6" onClick={this.retry} data-testid="error-retry-btn">Reintentar</button>
        <a href={backHref} className="mt-3 text-sm font-bold text-brand" data-testid="error-back-link">Volver</a>
      </div>
    );
  }
}
